import { Link } from "react-router-dom";


export const pollPredictionHandler = (location, slug) => {
  const currentPath = location.pathname;
  const key = slug.replace("-", "_");

  return {
    us_polls: (
      <Link
        to={`/us-polls/polling`}
        className={`py-2 nav-link-hover-poll ${currentPath === `/us-polls/polling` ? "font-bold" : "text-[#7F8FA4]"
          }`}
      >
        Polls
      </Link>
    ),
    canada_polls: (
      <Link
        to={`/canada-polls/polling`}
        className={`py-2 nav-link-hover-poll ${currentPath === `/canada-polls/polling` ? "font-bold" : "text-[#7F8FA4]"
          }`}
      >
        Polls
      </Link>
    ),
    [key]: (
      <Link
        to={`/${slug}/polling`}
        className={`py-2 nav-link-hover-poll ${currentPath === `/${slug}/polling` ? "font-bold" : "text-[#7F8FA4]"
          }`}
      >
        Polls
      </Link>
    )
  };
};



export const pollPredictionHandlerMob = (slug) => {
  const key = slug.replace("-", "_");

  return {
    us_polls: (
      <Link to={`/us-polls/polling`}>
        Check Polls
      </Link>
    ),
    canada_polls: (
      <Link to={`/canada-polls/polling`}>
        Check Polls
      </Link>
    ),
    [key]: (
      <Link to={`/${slug}/polling`}>
        Check Polls
      </Link>
    )
  };
};


export function formatBreadcrumbName(name) {
  return name
    .replace(/-/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}
export const isRowExceedingLimit = (row, tableData, PartyListResponse) => {
  const total = tableData?.reduce(
    (sum, entry) =>
      entry.categoryId === row.id
        ? sum + (parseFloat(entry.value) || 0)
        : sum,
    0
  );

  return row.category === "seats"
    ? total > PartyListResponse?.stateAndConstituencyData?.no_of_seats
    : total > 100;
};
export const handleSpaceInstatename = (stateName) => {
  return stateName?.replaceAll(" ", "-");
};
export function extractParties(row, suffix = 'Accuracy') {
  return Object?.keys(row)
    ?.filter((key) => key.includes(suffix))
    ?.map((key) => {
      if (key?.startsWith('AAP')) return 'AAP';
      if (key?.startsWith('BJP')) return 'BJP';
      if (key?.startsWith('INC')) return 'INC';
      if (key?.startsWith('Other') || key?.startsWith('Others')) return 'OTH';
      return key?.split('_')?.[0];
    });
}


